export default "__VITE_ASSET__89YSbAVL__"